export const DROPDOWN_PICKER_ITEM_TEST_ID = 'dropdown-picker-item-id';
export const DROPDOWN_PICKER_TEST_ID = 'dropdown-picker-test-id';
export const DROPDOWN_MENU_TEST_ID = 'dropdown-menu-test-id';
